<div class="inbuilt-card-v2-wrapper">
  @if (loading) {
  <div class="card-loader" aria-live="polite" aria-busy="true">
    <div class="spinner"></div>
    <div class="loader-text">Loading card data...</div>
  </div>
  } @if (!loading && noDataFound) {
  <div class="card-no-data">No data found.</div>
  } @if (!loading && !noDataFound) {
  <div class="inbuilt-card-v2">
    <p class="total-value">{{ totalDisplayValue }}</p>
    <hr class="value-divider" />
    @for (detail of details; track detail) {
    <p class="detail-row">
      <span class="detail-head">
        <span class="detail-label">{{ detail.label }}</span>
        <span class="detail-separator"> : </span>
      </span>
      <span class="detail-tail">
        <span class="detail-value">{{ detail.formattedValue }}</span>
        <span
          class="detail-percentage"
          [ngClass]="{
            'percentage-up': getPercentDirection(detail.percentage) === 'up',
            'percentage-down': getPercentDirection(detail.percentage) === 'down',
            'percentage-neutral': getPercentDirection(detail.percentage) === 'neutral'
          }"
        >
          @switch (getPercentDirection(detail.percentage)) { @case ('up') {
          <span class="percentage-arrow" aria-hidden="true">&uarr;</span>
          } @case ('down') {
          <span class="percentage-arrow" aria-hidden="true">&darr;</span>
          } @default {
          <span class="percentage-arrow" aria-hidden="true">&rarr;</span>
          } } ({{ formatPercentValue(detail.percentage) }})
        </span>
      </span>
    </p>
    }
  </div>
  }
</div>
